module.exports = __webpack_public_path__ + "static/media/bigVolumes.5b667662.gif";